import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const PowerPointFileIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 21 20" {...props}>
            <path
                d="M11.3333 1.66669H5.49992C5.05789 1.66669 4.63397 1.84228 4.32141 2.15484C4.00885 2.4674 3.83325 2.89133 3.83325 3.33335V16.6667C3.83325 17.1087 4.00885 17.5326 4.32141 17.8452C4.63397 18.1578 5.05789 18.3334 5.49992 18.3334H15.4999C15.9419 18.3334 16.3659 18.1578 16.6784 17.8452C16.991 17.5326 17.1666 17.1087 17.1666 16.6667V7.50002L11.3333 1.66669Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3333 1.66669V7.50002H17.1666"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.40356 15V11.8727H7.75342C7.98552 11.8727 8.18861 11.9186 8.36269 12.0102C8.53677 12.1018 8.67216 12.2306 8.76887 12.3965C8.86558 12.5624 8.91393 12.7564 8.91393 12.9783C8.91393 13.2022 8.86405 13.3962 8.76429 13.5601C8.66554 13.724 8.52659 13.8502 8.34742 13.9388C8.16927 14.0273 7.96109 14.0716 7.72288 14.0716H6.91663V13.4119H7.55186C7.65162 13.4119 7.73663 13.3946 7.80687 13.36C7.87813 13.3244 7.93259 13.274 7.97025 13.2089C8.00894 13.1437 8.02828 13.0668 8.02828 12.9783C8.02828 12.8887 8.00894 12.8123 7.97025 12.7492C7.93259 12.6851 7.87813 12.6362 7.80687 12.6026C7.73663 12.568 7.65162 12.5507 7.55186 12.5507H7.25257V15H6.40356Z"
                fill="currentColor"
                stroke="none"
            />
            <path
                d="M9.22544 15V11.8727H10.5753C10.8074 11.8727 11.0105 11.9186 11.1846 12.0102C11.3586 12.1018 11.494 12.2306 11.5907 12.3965C11.6875 12.5624 11.7358 12.7564 11.7358 12.9783C11.7358 13.2022 11.6859 13.3962 11.5862 13.5601C11.4874 13.724 11.3485 13.8502 11.1693 13.9388C10.9911 14.0273 10.783 14.0716 10.5448 14.0716H9.73851V13.4119H10.3737C10.4735 13.4119 10.5585 13.3946 10.6287 13.36C10.7 13.3244 10.7545 13.274 10.7921 13.2089C10.8308 13.1437 10.8502 13.0668 10.8502 12.9783C10.8502 12.8887 10.8308 12.8123 10.7921 12.7492C10.7545 12.6851 10.7 12.6362 10.6287 12.6026C10.5585 12.568 10.4735 12.5507 10.3737 12.5507H10.0744V15H9.22544Z"
                fill="currentColor"
                stroke="none"
            />
            <path
                d="M11.9618 12.5568V11.8727H14.6798V12.5568H13.7392V15H12.9024V12.5568H11.9618Z"
                fill="currentColor"
                stroke="none"
            />
        </SvgIcon>
    );
};
